import React, { useEffect, useState, useMemo } from "react";
import Main from "../components/custom/Main";
import PageContainer from "../components/custom/PageContainer";
import Card from "../components/custom/Card";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../redux/store";
import { StoreState } from "../redux/reducers";
import {
  ClearStudentFeeDetailsAction,
  fetchStudentFeeDetailsAction,
  StudentFeeDetails,
} from "../redux/actions/studentFeesDetailsAction";
import { toast, ToastContainer } from "react-toastify";
import { CourseType } from "./Interface";
import axios from "axios";
import { apiUrl } from "../config";
import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
import autoTable, { RowInput, CellInput } from "jspdf-autotable";
import * as Papa from "papaparse";
import "../styles/Table.css";
import { StudentAdmissionNo } from "./studentFeesByRegNo";
import StudentAdmissionDropdown from "../components/custom/components/StudentAdmissionDropdown";
import Feedback from "react-bootstrap/esm/Feedback";
import { title } from "process";

interface Option {
  value: string;
  label: string;
}

const StudentFeesDetails = () => {
  const dispatch = useDispatch<AppDispatch>();
  const studentFees = useSelector<StoreState, StudentFeeDetails[]>(
    (state) => state.studentFeesReducer,
  );
  const branchList = useSelector<StoreState, any[]>((state) => state.branch);

  const [courseList, setCourseList] = useState<CourseType[]>([]);
  const [branchId, setBranchId] = useState<string>("");
  const [courseId, setCourseId] = useState<string>("");
  const [batch, setBatch] = useState<string>("");
  const [admissionList, setAdmissionList] = useState<string[]>([]);
  const [isSearched, setIsSearched] = useState<boolean>(false);
  const [studentAdmissionNo, setStudentAdmissionNo] = useState<
    StudentAdmissionNo[]
  >([]);
  const [admissionNo, setAdmissionNo] = useState<string>("");
  const [years, setYears] = useState<string>("");

  useEffect(() => {
    dispatch(ClearStudentFeeDetailsAction());
  }, []);

  useEffect(() => {
    axios
      .get<{ data: CourseType[] }>(`${apiUrl}/course/`)
      .then((response) => setCourseList(response.data.data))
      .catch((error) => console.error("Error fetching courses: ", error));
  }, []);
  const fetchStuAdmNo = () => {
    axios
      .get<{ data: StudentAdmissionNo[] }>(
        `${apiUrl}/student/getAllStuAdmissionNo/`,
      )
      .then((response) => {
        setStudentAdmissionNo(response.data.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchStuAdmNo();
  }, []);
  const selectOptions: Option[] = useMemo(() => {
    return studentAdmissionNo.map((s) => ({
      value: s.admissionNumber,
      label: s.admissionNumber,
    }));
  }, [studentAdmissionNo]);

  const selectedCourse = useMemo(() => {
    return courseList.find((c) => c.id.toString() === courseId);
  }, [courseId, courseList]);

  const courseYears = useMemo(() => {
    const totalYears = Number(selectedCourse?.noOfYears);

    if (!totalYears || isNaN(totalYears)) return [];

    return Array.from({ length: totalYears }, (_, i) => i + 1);
  }, [selectedCourse]);

  const handleSearch = () => {
    if (!branchId || !courseId || !batch || !years) {
      toast.error("Please select branch, course batch and year");
      return;
    }
    dispatch(ClearStudentFeeDetailsAction());
    dispatch(
      fetchStudentFeeDetailsAction({
        branchId,
        courseId,
        batch,
        year: years,
        admissionNumber: admissionNo,
      }),
    );
    setIsSearched(true);
  };

  const handleClear = () => {
    setBranchId("");
    setCourseId("");
    setBatch("");
    setYears("");
    dispatch(ClearStudentFeeDetailsAction());
    setIsSearched(true);
  };

  const uniqueFeeTitles = useMemo(() => {
    const titles = new Set<string>();
    studentFees.forEach((student) => {
      student.fees?.forEach((fee) => {
        if (fee.title) titles.add(fee.title);
      });
    });
    return Array.from(titles).sort();
  }, [studentFees]);

  const getFeeByTitle = (fees: any[], title: string) => {
    return (
      fees.find((f: any) => f.title === title) || {
        amount: 0,
        paid: 0,
        balance: 0,
      }
    );
  };

  const last10Years = Array.from(
    { length: 11 },
    (_, i) => new Date().getFullYear() - i,
  );

  const downloadPDF = () => {
    if (studentFees.length === 0) {
      toast.error("No data to export");
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("YEAR WISE STUDENT FEES Details", pageWidth / 2, 12, {
      align: "center",
    });

    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");

    const branchName =
      branchList.find((b) => b.id.toString() === branchId)?.name || "All";

    const courseName =
      courseList.find((c) => c.id.toString() === courseId)?.name || "All";

    doc.text(
      `Branch: ${branchName} | Course: ${courseName} | Batch: ${batch || "All"} | AcademicPeriod:${years || "All"}`,
      pageWidth / 2,
      18,
      { align: "center" },
    );

    const uniqueFeeTitles = Array.from(
      new Set(studentFees.flatMap((s) => s.fees.map((f) => f.title))),
    );

    const head: RowInput[] = [
      [
        { content: "S.No", rowSpan: 2 } as CellInput,
        { content: "Admission/Name", rowSpan: 2 } as CellInput,
        // { content: "Name", rowSpan: 2 } as CellInput,
        ...uniqueFeeTitles.map(
          (title) =>
            ({
              content: title.toUpperCase(),
              colSpan: 3,
              styles: { halign: "center" },
            }) as CellInput,
        ),
      ],
      [
        ...uniqueFeeTitles.flatMap(
          () =>
            [
              { content: "Due", styles: { halign: "center" } },
              { content: "Paid", styles: { halign: "center" } },
              { content: "Balance", styles: { halign: "center" } },
            ] as CellInput[],
        ),
      ],
    ];
    const body: RowInput[] = studentFees.map((student, index) => {
      const row: (string | number)[] = [
        index + 1,
        `${student.admissionNumber} \n ${student.studentName}`,
      ];

      uniqueFeeTitles.forEach((title) => {
        const fee = student.fees.find((f) => f.title === title);
        row.push(fee?.amount ?? 0);
        row.push(fee?.paid ?? 0);
        row.push(fee?.balance ?? 0);
      });

      return row;
    });

    const totalDue = uniqueFeeTitles.map((title) =>
      studentFees.reduce((sum, s) => {
        const fee = s.fees.find((f) => f.title === title);
        return sum + (fee?.amount ?? 0);
      }, 0),
    );

    const totalPaid = uniqueFeeTitles.map((title) =>
      studentFees.reduce((sum, s) => {
        const fee = s.fees.find((f) => f.title === title);
        return sum + (fee?.paid ?? 0);
      }, 0),
    );

    const totalBalance = uniqueFeeTitles.map((title) =>
      studentFees.reduce((sum, s) => {
        const fee = s.fees.find((f) => f.title === title);
        return sum + (fee?.balance ?? 0);
      }, 0),
    );

    const foot: RowInput[] = [
      [
        {
          content: "Overall Total",
          colSpan: 2,
          styles: { halign: "right", fontStyle: "bold" },
        },

        ...uniqueFeeTitles.flatMap((_, i) => [
          totalDue[i],
          totalPaid[i],
          totalBalance[i],
        ]),
      ],
    ];

    autoTable(doc, {
      head,
      body,
      foot,
      startY: 25,
      theme: "grid",
      showFoot: "lastPage",

      styles: {
        fontSize: 7,
        cellPadding: 1.5,
        textColor: [0, 0, 0],
        halign: "center",
        lineColor: [0, 0, 0],
      },

      headStyles: {
        fillColor: false,
        textColor: [0, 0, 0],
        fontStyle: "bold",
        fontSize: 8,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      footStyles: {
        fontStyle: "bold",
        fillColor: false,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },

      didParseCell: (data) => {
        if (data.section === "body" && data.column.index === 1) {
          data.cell.styles.fontSize = 9;
          data.cell.styles.halign = "left";
        }

        if (data.section === "body" && data.column.index >= 2) {
          data.cell.styles.fontSize = 9;
          data.cell.styles.halign = "right";
        }

        if (data.section === "body") {
          const colIndex = data.column.index;

          if ((colIndex - 2) % 3 === 2) {
            const value = Number(data.cell.text);

            if (value > 0) {
              data.cell.styles.textColor = [200, 0, 0];
            } else {
              data.cell.styles.textColor = [0, 0, 0];
            }
          }
        }
      },

      didDrawPage: () => {
        const pageHeight = doc.internal.pageSize.getHeight();
        const pageNumber = doc.getNumberOfPages();

        doc.setFontSize(8);
        doc.text(`Page ${pageNumber}`, pageWidth - 25, pageHeight - 8);
      },
    });

    doc.save(
      `Student_Fees_${batch || "All"}_${
        new Date().toISOString().split("T")[0]
      }.pdf`,
    );

    // toast.success("PDF downloaded successfully!");
  };

  const downloadCSV = () => {
    if (studentFees.length === 0) {
      toast.error("No data to export");
      return;
    }

    const csvHeaders = ["S.No", "Admission No", "Name", "Year"];
    uniqueFeeTitles.forEach((title) => {
      csvHeaders.push(`${title}-Due`, `${title}-Paid`, `${title}-Balance`);
    });

    const csvRows = studentFees.map((student, index) => {
      const row: any = {
        "S.No": index + 1,
        "Admission No": student.admissionNumber || "",
        Name: student.studentName || "",
        Year: student.academicPeriod || "",
      };

      uniqueFeeTitles.forEach((title) => {
        const fee = student.fees?.find((f) => f.title === title) || {
          amount: 0,
          paid: 0,
          balance: 0,
        };
        row[`${title}-Due`] = fee.amount || 0;
        row[`${title}-paid`] = fee.paid || 0;
        row[`${title}-Balance`] = fee.balance || 0;
      });

      return row;
    });

    const csv = Papa.unparse(
      {
        fields: csvHeaders,
        data: csvRows,
      },
      {
        delimiter: ",",
        quotes: true,
        quoteChar: '"',
        escapeChar: '"',
        header: true,
        newline: "\r\n",
      },
    );

    const blob = new Blob(["\uFEFF" + csv], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `student_fees_${batch || "all"}_${new Date().toISOString().split("T")[0]}.csv`,
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    // toast.success("CSV downloaded successfully!");
  };

  return (
    <Main>
      <PageContainer title="Year Wise Student Fees Details">
        <Card title="Student Fees">
          <div className="row mb-4">
            <div className="col-sm-6 col-md-4 col-lg-3">
              <label className="mt-3 mb-2">Branch:</label>
              <select
                className="form-control form-select"
                value={branchId}
                onChange={(e) => setBranchId(e.target.value)}
              >
                <option value="">Select Branch</option>
                {branchList.map((branch) => (
                  <option key={branch.id} value={branch.id}>
                    {branch.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-3">
              <label className="mt-3 mb-2">Course:</label>
              <select
                className="form-control form-select"
                value={courseId}
                onChange={(e) => setCourseId(e.target.value)}
              >
                <option value="">Select Course</option>
                {courseList
                  .filter(
                    (f) =>
                      !branchId ||
                      f.branchId?.toString() === branchId.toString(),
                  )
                  .map((course) => (
                    <option key={course.id} value={course.id}>
                      {course.name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-3">
              <label className="mt-3 mb-2">Year:</label>
              <select
                className="form-control form-select"
                value={years}
                onChange={(e) => setYears(e.target.value)}
              >
                <option value="">Select Year</option>

                {courseYears.map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-sm-6 col-md-4 col-lg-3">
              <label className="mt-3 mb-2">Batch:</label>
              <select
                className="form-control form-select"
                value={batch}
                onChange={(e) => setBatch(e.target.value)}
              >
                <option value="">Select Batch</option>
                {last10Years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
            {/* <div className="col-sm-6 col-md-4 col-lg-3">
              <label className="mt-3 mb-2">Admission No:</label>
              <select
                className="form-control form-select"
                value={admissionNumber}
                onChange={(e) => setAdmissionNumber(e.target.value)}
                // disabled={!admissionList.length}
              >
                <option value="">All Admissions</option>
                {admissionList.map((adm) => (
                  <option key={adm} value={adm}>
                    {adm}
                  </option>
                ))}
              </select>
              <StudentAdmissionDropdown
                selectOptions={selectOptions}
                setAdmissionNo={setAdmissionNo}
                admissionNo={admissionNo}
              />
            </div> */}
            <div className="d-flex align-items-end justify-content-end gap-2 mt-3 mb-3">
              <button
                className="btn btn-primary"
                onClick={handleSearch}
                style={{ fontSize: "14px" }}
              >
                Search
              </button>
              <button
                className="btn btn-secondary"
                onClick={handleClear}
                style={{ fontSize: "14px" }}
              >
                Clear
              </button>
            </div>
            {isSearched && (
              <div className="d-flex justify-content-end gap-2 mb-3">
                <button
                  className="btn btn-success btn-sm"
                  onClick={downloadPDF}
                  disabled={studentFees.length === 0}
                >
                  PDF
                </button>
                <button
                  className="btn btn-success btn-sm text-white"
                  onClick={downloadCSV}
                  disabled={studentFees.length === 0}
                >
                  <i className="bi bi-file-earmark-excel"></i>CSV
                </button>
              </div>
            )}
          </div>
          <div
            className="table-container mt-5"
            style={{ maxHeight: "500px", overflowY: "auto" }}
          >
            <table className="table table-bordered table-striped text-center align-middle">
              <thead className="table-dark">
                <tr>
                  <th
                    rowSpan={2}
                    style={{ verticalAlign: "middle", minWidth: "50px" }}
                  >
                    S.No
                  </th>
                  <th rowSpan={2} style={{ verticalAlign: "middle" }}>
                    Admission No
                  </th>
                  <th rowSpan={2} style={{ verticalAlign: "middle" }}>
                    Name
                  </th>
                  <th rowSpan={2} style={{ verticalAlign: "middle" }}>
                    Year
                  </th>
                  {uniqueFeeTitles.map((title) => (
                    <th
                      key={title}
                      colSpan={3}
                      style={{ backgroundColor: "#2c3e50", padding: "15px" }}
                    >
                      {title.toUpperCase()}
                    </th>
                  ))}
                  <th rowSpan={2} style={{ verticalAlign: "middle" }}>
                    Total Due
                  </th>
                  <th rowSpan={2} style={{ verticalAlign: "middle" }}>
                    Total Paid
                  </th>
                  <th rowSpan={2} style={{ verticalAlign: "middle" }}>
                    Total Balance
                  </th>
                </tr>
                <tr>
                  {uniqueFeeTitles.map((title) => (
                    <React.Fragment key={title}>
                      <th style={{ fontSize: "12px", padding: "4px" }}>Due</th>
                      <th style={{ fontSize: "12px", padding: "4px" }}>Paid</th>
                      <th style={{ fontSize: "12px", padding: "4px" }}>
                        Balance
                      </th>
                    </React.Fragment>
                  ))}
                </tr>
              </thead>
              <tbody>
                {studentFees.length === 0 ? (
                  <tr>
                    <td colSpan={3 + uniqueFeeTitles.length * 2}>
                      <span className="text-muted">No records found</span>
                    </td>
                  </tr>
                ) : (
                  studentFees.map((student, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{student.admissionNumber}</td>
                        <td>{student.studentName}</td>
                        <td>{student.academicPeriod}</td>
                        {uniqueFeeTitles.map((title) => {
                          const fee = getFeeByTitle(student.fees || [], title);
                          return (
                            <React.Fragment key={title}>
                              <td
                                style={{
                                  fontWeight: "600",
                                  color: "#6c757d",
                                }}
                              >
                                {fee.amount > 0
                                  ? `${fee.amount.toLocaleString()}`
                                  : "-"}
                              </td>
                              <td
                                style={{
                                  fontWeight: "600",
                                  color: fee.paid > 0 ? "#28a745" : "#6c757d",
                                }}
                              >
                                {fee.paid > 0
                                  ? `${fee.paid.toLocaleString()}`
                                  : "0"}
                              </td>
                              <td
                                style={{
                                  color:
                                    fee.balance > 0 ? "#dc3545" : "#28a745",
                                  fontWeight: "600",
                                }}
                              >
                                {fee.balance > 0
                                  ? `${fee.balance.toLocaleString()}`
                                  : "0"}
                              </td>
                            </React.Fragment>
                          );
                        })}
                        <td>{Number(student.totalAmount).toFixed(2)}</td>
                        <td>{Number(student.totalPaid).toFixed(2)}</td>
                        <td>{Number(student.totalBalance).toFixed(2)}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </Card>
        <ToastContainer />
      </PageContainer>
    </Main>
  );
};

export default StudentFeesDetails;
